
/* =====================================
   CALO - SCROLL CONTROLLED STEPS
   ===================================== */

(function () {

  const SELECTOR =
    '[id$="__tpt_step_1_aHTe3P"]';

  function initCaloScroll() {

    const outer = document.querySelector(SELECTOR);

    if (!outer || outer.dataset.caloScrollReady) return;

    const content = outer.querySelector(
      '.tpt-section_content'
    );

    const body = outer.querySelector(
      '.tpt-section-body'
    );

    const container = outer.querySelector(
      '.tpt-steps-container'
    );

    const media = outer.querySelector(
      '.tpt-steps-media'
    );

    const steps = [
      ...outer.querySelectorAll('.tpt-step-item')
    ];

    const images = [
      ...outer.querySelectorAll('.tpt-media-item')
    ];

    if (
      !content ||
      !body ||
      !container ||
      !media ||
      !steps.length ||
      steps.length !== images.length
    ) {
      return;
    }

    outer.dataset.caloScrollReady = 'true';

    /* Create sticky wrapper for heading + body */

    let sticky = content.querySelector(
      '.calo-sticky-inner'
    );

    if (!sticky) {

      sticky = document.createElement('div');

      sticky.className = 'calo-sticky-inner';

      const elements = Array.from(content.children);

      content.prepend(sticky);

      elements.forEach(element => {

        if (element !== sticky) {
          sticky.appendChild(element);
        }

      });
    }

    /* Scroll-controlled feature switching */

    let currentStep = -1;

    function updateCaloScroll() {

      const rect = content.getBoundingClientRect();

      const scrollDistance =
        content.offsetHeight - window.innerHeight;

      if (scrollDistance <= 0) return;

      const progress = Math.max(
        0,
        Math.min(1, -rect.top / scrollDistance)
      );

      const nextStep = Math.min(
        steps.length - 1,
        Math.floor(progress * steps.length)
      );

      if (nextStep === currentStep) return;

      currentStep = nextStep;

      steps.forEach((step, index) => {

        step.classList.toggle(
          'active',
          index === nextStep
        );

      });

      images.forEach((image, index) => {

        image.classList.toggle(
          'active',
          index === nextStep
        );

      });
    }

    window.addEventListener(
      'scroll',
      updateCaloScroll,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateCaloScroll
    );

    updateCaloScroll();
  }

  /* Initialise after page load */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initCaloScroll
    );

  } else {

    initCaloScroll();

  }

})();

